import { render, staticRenderFns } from "./AddTabletDialog.vue?vue&type=template&id=f9ead3fa&scoped=true"
import script from "./AddTabletDialog.vue?vue&type=script&lang=js"
export * from "./AddTabletDialog.vue?vue&type=script&lang=js"
import style0 from "./AddTabletDialog.vue?vue&type=style&index=0&id=f9ead3fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ead3fa",
  null
  
)

export default component.exports